// import React, { useState, useEffect } from "react";
// import search from "../Assets/rider/search.svg";
// import Select, { components } from "react-select";
// import { useSelector } from "react-redux";
// import inr from "../Assets/support/inr.webp";
// import issueicon from "../Assets/support/issue.png";
// import clock from "../Assets/Detailstable/clock.svg";
// import delay from "../Assets/support/d1.png";
// import eye from "../Assets/rider/eye.svg";
// import "../Style/Pages/Helpandsupport.css";
// import { GrOverview } from "react-icons/gr";
// import { getWithTokenAPI, putWithTokenAPI } from "../Util/Api";
// import { toast } from "react-toastify";
// import { FcDeleteDatabase } from "react-icons/fc";
// import { IssueCardSkeleton } from "../Component/Skeleton";
// const Helpandsupport = () => {
//   const [searchText, setSearchText] = useState("");
//   const auth = useSelector((state) => state.auth);
//   const permission = auth.permission;
//   const token = auth.token;
//   const [loading, setLoading] = useState(false);
//   const statusOptions = [
//     { value: "PENDING", label: "PENDING" },
//     { value: "OPEN", label: "OPEN" },
//     { value: "INPROGRESS", label: "INPROGRESS" },
//     { value: "RESOLVED", label: "RESOLVED" },
//   ];
//   const liststatusOptions = [
//     { value: "PENDING", label: "PENDING" },

//     { value: "OPEN", label: "OPEN" },
//     { value: "INPROGRESS", label: "INPROGRESS" },
//     { value: "RESOLVED", label: "RESOLVED" },
//   ];
//   const [liststatus, setListStatus] = useState("PENDING");
//   const [status, setStatus] = useState("");
//   const [helplist, setHelplist] = useState([]);
//   const fetchhelplist = async () => {
//     try {
//       setLoading(true);
//       const res = await getWithTokenAPI(
//         token,
//         `/help-support/list?status=${liststatus}`,
//       );

//       setHelplist(res?.data);
//     } catch (err) {
//       console.log("Error fetching list", err);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     fetchhelplist();
//   }, [token, liststatus, status]);
//   const [help, setHelp] = useState({});
//   const fetchhelp = async (issueid) => {
//     try {
//       const res = await getWithTokenAPI(
//         token,
//         `/help-support/get?id=${issueid}`,
//       );

//       setHelp(res?.data);
//       setStatus(res?.data?.status);
//     } catch (err) {
//       console.log("Error fetching list", err);
//     }
//   };
//   const handleUpdatestatus = async (value) => {
//     const payload = {
//       status: value,
//     };
//     try {
//       const res = await putWithTokenAPI(
//         token,
//         `/help-support/update/${help?._id}`,
//         payload,
//       );
//       if (res?.data) {
//         toast.success("Status Updated Successfully");
//       }
//     } catch (err) {
//       console.log(err);
//       toast.error("Status Updation Failed");
//     }
//   };
//   function limitWords(text, wordLimit = 5) {
//     if (!text) return "";

//     const words = text.trim().split(/\s+/);

//     if (words.length <= wordLimit) {
//       return text;
//     }

//     return words.slice(0, wordLimit).join(" ") + "...";
//   }
//   function timeAgo(timestamp) {
//     const now = new Date();
//     const past = new Date(timestamp);

//     const diffInMs = now - past;
//     const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
//     const diffInDays = Math.floor(diffInHours / 24);

//     if (diffInHours < 1) {
//       const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
//       return `${diffInMinutes} mins ago`;
//     }

//     if (diffInHours < 24) {
//       return `${diffInHours} hrs ago`;
//     }

//     return `${diffInDays} days ago`;
//   }
//   const getIcon = (issue) => {
//     if (!issue) return issueicon;

//     const text = issue.toLowerCase();

//     const moneyKeywords = [
//       "money",
//       "payment",
//       "transaction",
//       "amount",
//       "cash",
//       "refund",
//       "charge",
//       "deduct",
//       "wallet",
//     ];

//     const timeKeywords = [
//       "time",
//       "delay",
//       "late",
//       "early",
//       "wait",
//       "waiting",
//       "hours",
//       "minutes",
//     ];

//     if (moneyKeywords.some((word) => text.includes(word))) {
//       return inr; // 💰 money icon
//     }

//     if (timeKeywords.some((word) => text.includes(word))) {
//       return delay; // ⏳ time icon
//     }

//     return issueicon; // default issue icon
//   };
//   const customStylessupport = {
//     control: (base, state) => ({
//       ...base,
//       minHeight: "36px",
//       height: "36px",
//       width: "130px",
//       border: "1px solid grey",
//       borderRadius: "10px",
//       boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
//       backgroundColor: "white",
//       cursor: "pointer",
//     }),

//     valueContainer: (base) => ({
//       ...base,
//       padding: "0 8px",
//       height: "36px",
//     }),

//     singleValue: (base) => ({
//       ...base,
//       color: "#555",
//       fontSize: "14px",
//       fontWeight: "500",
//       margin: 0,
//       lineHeight: "36px",
//       top: "0",
//       transform: "none",
//     }),

//     placeholder: (base) => ({
//       ...base,
//       color: "#888",
//       fontSize: "14px",
//       fontWeight: "500",
//     }),

//     dropdownIndicator: (base) => ({
//       ...base,
//       color: "#666",
//       padding: "0 10px",
//       "&:hover": {
//         color: "#333",
//       },
//     }),

//     indicatorSeparator: () => ({
//       display: "none",
//     }),

//     option: (base, state) => ({
//       ...base,
//       backgroundColor: state.isSelected
//         ? "#013A28"
//         : state.isFocused
//           ? "#02543a53"
//           : "white",
//       color: state.isSelected ? "white" : "#333",
//       cursor: "pointer",
//       ":hover": {
//         backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
//       },
//     }),

//     menu: (base) => ({
//       ...base,
//       borderRadius: "8px",
//       boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
//       zIndex: 9999,
//     }),

//     menuList: (base) => ({
//       ...base,
//       padding: 0,
//       maxHeight: "180px",
//       overflowY: "auto",
//       // zIndex: 99,

//       "&::-webkit-scrollbar": {
//         width: "6px",
//       },
//       "&::-webkit-scrollbar-track": {
//         background: "#013a2826",
//       },
//       "&::-webkit-scrollbar-thumb": {
//         background: "#013a2855",
//         borderRadius: "3px",
//       },
//     }),
//   };
//   return (
//     <div className="helpandsupport">
//       <div className="riderpagetop">
//         <span className="ridertophead">Help and Support</span>
//         <div className="ridertopfilter">
//           <div className="searchbar">
//             <img src={search} alt="search" />
//             <input
//               className="searchinput"
//               type="text"
//               placeholder="Search"
//               value={searchText}
//               onChange={(e) => setSearchText(e.target.value)}
//             />
//           </div>
//         </div>
//       </div>
//       <div className="helpandsupportbottom">
//         <div className="helpandsupportbottomlist">
//           <span className="supporthead">Tickets List</span>
//           <Select
//             className="da"
//             value={liststatusOptions.find(
//               (option) => option.value === liststatus,
//             )}
//             options={liststatusOptions}
//             styles={customStylessupport}
//             onChange={(selected) => setListStatus(selected.value)}
//             isSearchable={false}
//             menuPlacement="bottom"
//             // menuPortalTarget={document.body}
//             menuPosition="fixed"
//             components={{
//               IndicatorSeparator: null,
//             }}
//           />
//           {loading ? (
//             <IssueCardSkeleton />
//           ) : (
//             <div className="supportbody">
//               {helplist?.length > 0 ? (
//                 helplist?.map((item, index) => (
//                   <div
//                     className={`supportcard  ${
//                       item?.status === "INPROGRESS"
//                         ? "prog"
//                         : item?.status === "RESOLVED"
//                           ? "comp"
//                           : ""
//                     }`}
//                     onClick={() => fetchhelp(item?._id)}
//                   >
//                     <img
//                       src={getIcon(item?.issue)}
//                       alt="inr"
//                       className="tokenicon"
//                     />
//                     <div className="supportcardright">
//                       <div className="firstline">
//                         <span
//                           className="name"
//                           style={{
//                             fontSize: "16px",
//                             fontWeight: "500",
//                             color: "var(--primary)",
//                           }}
//                         >
//                           {item?.name}
//                         </span>
//                         <span
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             color: "grey",
//                           }}
//                         >
//                           <img
//                             src={clock}
//                             alt="clock"
//                             style={{
//                               width: "15px",
//                               height: "15px",
//                             }}
//                           />
//                           {timeAgo(item?.createdAt)}
//                         </span>
//                       </div>
//                       <span className="secondline">
//                         {limitWords(item?.issue)}
//                       </span>
//                       <div className="thirdline">
//                         {/* <img
//                           src={eye}
//                           style={{
//                             cursor: "pointer",
//                             width: "18px",
//                             height: "18px",
//                           }}
//                           alt="eye"
//                           className="eyeicon"
//                           onClick={() => fetchhelp(item?._id)}
//                         /> */}
//                         <span>
//                           Status:
//                           <span
//                             className={`supportstatus ${
//                               item?.status === "INPROGRESS"
//                                 ? "inprogress"
//                                 : item?.status === "RESOLVED"
//                                   ? "resolved"
//                                   : ""
//                             }`}
//                           >
//                             {item?.status}
//                           </span>
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="defaul">
//                   <FcDeleteDatabase
//                     style={{ fontSize: "100px", color: "#e85c5c" }}
//                   />
//                   <h3>No Data Available</h3>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         <div className="helpandsupportbottomspecific">
//           <span className="supporthead" style={{ marginLeft: "38%" }}>
//             Ticket Details
//           </span>
//           {help?._id ? (
//             <>
//               {permission?.helpandsupport?.update && (
//                 <div className="hsstatus">
//                   <span>Status:</span>
//                   {status === "RESOLVED" ? (
//                     <span className="resolved">RESOLVED</span>
//                   ) : (
//                     <Select
//                       className="dd"
//                       value={statusOptions.find(
//                         (option) => option.value === status,
//                       )}
//                       options={statusOptions}
//                       styles={customStylessupport}
//                       onChange={(selected) => {
//                         setStatus(selected.value);
//                         handleUpdatestatus(selected.value);
//                       }}
//                       isSearchable={false}
//                       // isDisabled={status === "RESOLVED"}
//                       menuPlacement="bottom"
//                       // menuPortalTarget={document.body}
//                       menuPosition="fixed"
//                       components={{
//                         IndicatorSeparator: null,
//                       }}
//                     />
//                   )}
//                 </div>
//               )}
//               <div className="specifictoken">
//                 <img src={getIcon(help?.issue)} className="issueicon"></img>
//                 <span className="supportinp">
//                   <span className="inphead">Ticket Id:</span>
//                   <span>{help?.ticketId}</span>
//                 </span>
//                 <span className="supportinp">
//                   <span className="inphead">Name:</span>
//                   <span>{help?.name}</span>
//                 </span>
//                 <span className="supportinp">
//                   <span className="inphead">Phone:</span>
//                   <span>{help?.phone}</span>
//                 </span>
//                 <span className="supportinp">
//                   <span className="inphead">Issue:</span>
//                   <span className="issuescontent">{help?.issue}</span>
//                 </span>
//               </div>
//             </>
//           ) : (
//             <div className="defaul">
//               <GrOverview style={{ fontSize: "100px", color: "#e85c5c" }} />
//               <h3>
//                 {loading
//                   ? "Waiting for Data"
//                   : "Select Any Ticket To view Details"}
//               </h3>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Helpandsupport;




import React, { useState, useEffect } from "react";
import search from "../Assets/rider/search.svg";
import Select, { components } from "react-select";
import { useSelector } from "react-redux";
import inr from "../Assets/support/inr.webp";
import issueicon from "../Assets/support/issue.png";
import clock from "../Assets/Detailstable/clock.svg";
import delay from "../Assets/support/d1.png";
import eye from "../Assets/rider/eye.svg";
import "../Style/Pages/Helpandsupport.css";
import { GrOverview } from "react-icons/gr";
import { getWithTokenAPI, putWithTokenAPI } from "../Util/Api";
import { toast } from "react-toastify";
import { FcDeleteDatabase } from "react-icons/fc";
import { IssueCardSkeleton } from "../Component/Skeleton";
// Import status log icons - Fixed imports
import { HiOutlineClock } from "react-icons/hi";
import { MdOutlinePendingActions } from "react-icons/md";
import { VscIssueReopened } from "react-icons/vsc";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { BiTime } from "react-icons/bi"; // Alternative for progress

const Helpandsupport = () => {
  const [searchText, setSearchText] = useState("");
  const auth = useSelector((state) => state.auth);
  const permission = auth.permission;
  const token = auth.token;
  const [loading, setLoading] = useState(false);
  const [showStatusLogs, setShowStatusLogs] = useState(false); // For toggling status logs

  const statusOptions = [
    { value: "PENDING", label: "PENDING" },
    { value: "OPEN", label: "OPEN" },
    { value: "INPROGRESS", label: "INPROGRESS" },
    { value: "RESOLVED", label: "RESOLVED" },
  ];

  const liststatusOptions = [
    { value: "PENDING", label: "PENDING" },
    { value: "OPEN", label: "OPEN" },
    { value: "INPROGRESS", label: "INPROGRESS" },
    { value: "RESOLVED", label: "RESOLVED" },
  ];

  const [liststatus, setListStatus] = useState("PENDING");
  const [status, setStatus] = useState("");
  const [helplist, setHelplist] = useState([]);

  const fetchhelplist = async () => {
    try {
      setLoading(true);
      const res = await getWithTokenAPI(
        token,
        `/help-support/list?status=${liststatus}`,
      );
      setHelplist(res?.data);
    } catch (err) {
      console.log("Error fetching list", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchhelplist();
  }, [token, liststatus, status]);

  const [help, setHelp] = useState({});

  const fetchhelp = async (issueid) => {
    try {
      const res = await getWithTokenAPI(
        token,
        `/help-support/get?id=${issueid}`,
      );
      setHelp(res?.data);
      setStatus(res?.data?.status);
      setShowStatusLogs(true); // Auto expand status logs when ticket selected
    } catch (err) {
      console.log("Error fetching list", err);
    }
  };

  const handleUpdatestatus = async (value) => {
    const payload = {
      status: value,
    };
    try {
      const res = await putWithTokenAPI(
        token,
        `/help-support/update/${help?._id}`,
        payload,
      );
      if (res?.data) {
        toast.success("Status Updated Successfully");
        // Refresh ticket details to get updated status logs
        fetchhelp(help?._id);
      }
    } catch (err) {
      console.log(err);
      toast.error("Status Updation Failed");
    }
  };

  // Function to get status icon
  const getStatusIcon = (status) => {
    switch (status) {
      case "PENDING":
        return <MdOutlinePendingActions className="status-icon pending" />;
      case "OPEN":
        return <VscIssueReopened className="status-icon open" />;
      case "INPROGRESS":
        return <BiTime className="status-icon inprogress" />; // Using BiTime as alternative
      case "RESOLVED":
        return <IoCheckmarkDoneCircleOutline className="status-icon resolved" />;
      default:
        return <HiOutlineClock className="status-icon" />;
    }
  };

  // Function to format date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  function limitWords(text, wordLimit = 5) {
    if (!text) return "";
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) {
      return text;
    }
    return words.slice(0, wordLimit).join(" ") + "...";
  }

  function timeAgo(timestamp) {
    const now = new Date();
    const past = new Date(timestamp);
    const diffInMs = now - past;
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInHours < 1) {
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      return `${diffInMinutes} mins ago`;
    }
    if (diffInHours < 24) {
      return `${diffInHours} hrs ago`;
    }
    return `${diffInDays} days ago`;
  }

  const getIcon = (issue) => {
    if (!issue) return issueicon;
    const text = issue.toLowerCase();
    const moneyKeywords = [
      "money", "payment", "transaction", "amount", "cash",
      "refund", "charge", "deduct", "wallet"
    ];
    const timeKeywords = [
      "time", "delay", "late", "early", "wait",
      "waiting", "hours", "minutes"
    ];

    if (moneyKeywords.some((word) => text.includes(word))) {
      return inr;
    }
    if (timeKeywords.some((word) => text.includes(word))) {
      return delay;
    }
    return issueicon;
  };

  const customStylessupport = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      width: "130px",
      border: "1px solid grey",
      borderRadius: "10px",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
      backgroundColor: "white",
      cursor: "pointer",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      height: "36px",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#555",
      fontSize: "14px",
      fontWeight: "500",
      margin: 0,
      lineHeight: "36px",
      top: "0",
      transform: "none",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#888",
      fontSize: "14px",
      fontWeight: "500",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#666",
      padding: "0 10px",
      "&:hover": {
        color: "#333",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#013A28"
        : state.isFocused
          ? "#02543a53"
          : "white",
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      ":hover": {
        backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a2826",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2855",
        borderRadius: "3px",
      },
    }),
  };

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      minHeight: "30px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };
  return (
    <div className="helpandsupport">
      <div className="riderpagetop">
        <span className="ridertophead">Help and Support</span>
        <div className="ridertopfilter">
          <div className="searchbar">
            <img src={search} alt="search" />
            <input
              className="searchinput"
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="helpandsupportbottom">
        <div className="helpandsupportbottomlist">
          <span className="supporthead">Tickets List</span>
          <Select
            className="da"
            value={liststatusOptions.find(
              (option) => option.value === liststatus,
            )}
            options={liststatusOptions}
            styles={customStylessupport}
            onChange={(selected) => setListStatus(selected.value)}
            isSearchable={false}
            menuPlacement="bottom"
            menuPosition="fixed"
            components={{
              IndicatorSeparator: null,
            }}
          />

          {loading ? (
            <IssueCardSkeleton />
          ) : (
            <div className="supportbody">
              {helplist?.length > 0 ? (
                helplist?.map((item, index) => (
                  <div
                    className={`supportcard ${item?.status === "INPROGRESS"
                        ? "prog"
                        : item?.status === "RESOLVED"
                          ? "comp"
                          : ""
                      }`}
                    onClick={() => fetchhelp(item?._id)}
                    key={item?._id}
                  >
                    <img
                      src={getIcon(item?.issue)}
                      alt="inr"
                      className="tokenicon"
                    />
                    <div className="supportcardright">
                      <div className="firstline">
                        <span
                          className="name"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "var(--primary)",
                          }}
                        >
                          {item?.name}
                        </span>
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            color: "grey",
                          }}
                        >
                          <img
                            src={clock}
                            alt="clock"
                            style={{
                              width: "15px",
                              height: "15px",
                              marginRight: "4px",
                            }}
                          />
                          {timeAgo(item?.createdAt)}
                        </span>
                      </div>
                      <span className="secondline">
                        {limitWords(item?.issue)}
                      </span>
                      <div className="thirdline">
                        <span>
                          Status:
                          <span
                            className={`supportstatus ${item?.status === "INPROGRESS"
                                ? "inprogress"
                                : item?.status === "RESOLVED"
                                  ? "resolved"
                                  : ""
                              }`}
                          >
                            {item?.status}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="defaul">
                  <FcDeleteDatabase
                    style={{ fontSize: "100px", color: "#e85c5c" }}
                  />
                  <h3>No Data Available</h3>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="helpandsupportbottomspecific">
          {/* <span className="supporthead" style={{ marginLeft: "38%" }}>
            Ticket Details
          </span> */}

          {help?._id ? (
            <>
              <div className="specifictoken">
                <img src={getIcon(help?.issue)} className="issueicon" alt="issue" />
                <span className="supportinp">
                  <span className="inphead">Ticket Id:</span>
                  <span>{help?.ticketId}</span>
                </span>
                <span className="supportinp">
                  <span className="inphead">Name:</span>
                  <span>{help?.name}</span>
                </span>
                <span className="supportinp">
                  <span className="inphead">Phone:</span>
                  <span>{help?.phone}</span>
                </span>
                <span className="supportinp">
                  <span className="inphead">Issue:</span>
                  <span className="issuescontent">{help?.issue}</span>
                </span>

                {permission?.helpandsupport?.update && (
                  <div className="supportinp" style={{ padding: "5px 15px" }}>
                    <span>Status:</span>

                    {status === "RESOLVED" ? (
                      <span className="resolved">RESOLVED</span>
                    ) : (
                      <Select
                        className="dd"
                        value={statusOptions.find((option) => option.value === status)}
                        options={statusOptions}
                        styles={customSelectStyles}
                        onChange={(selected) => {
                          setStatus(selected.value);
                          handleUpdatestatus(selected.value);
                        }}
                        isSearchable={false}
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        components={{ IndicatorSeparator: null }}
                      />
                    )}
                  </div>
                )}

              </div>

              {/* Modern Status Logs Section */}
              {help?.statusLogs && help.statusLogs.length > 0 && (
                <div className="status-logs-container">
                  <div
                    className="status-logs-header"
                    onClick={() => setShowStatusLogs(!showStatusLogs)}
                  >
                    <div className="status-logs-title">
                      <HiOutlineClock className="logs-icon" />
                      <span>Status History</span>
                      <span className="logs-count">
                        ({help.statusLogs.length})
                      </span>
                    </div>
                    <span className={`toggle-icon ${showStatusLogs ? 'expanded' : ''}`}>
                      ▼
                    </span>
                  </div>

                  {showStatusLogs && (
                    <div className="status-timeline">
                      {help.statusLogs.map((log, index) => (
                        <div key={log._id || index} className="timeline-item">
                          <div className="timeline-line">
                            <div className="timeline-dot"></div>
                            {index < help.statusLogs.length - 1 && (
                              <div className="timeline-connector"></div>
                            )}
                          </div>

                          <div className="timeline-content">
                            <div className="status-badge-wrapper">

                              {getStatusIcon(log.status)}
                              <span className={`status-badge ${log.status.toLowerCase()}`}>
                                {log.status}
                              </span>
                            </div>
                            <span className="timeline-date">
                              {`${log.adminName} - ${log.roleType} - ${formatDate(log.updatedAt)}`}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className="defaul">
              <GrOverview style={{ fontSize: "100px", color: "#e85c5c" }} />
              <h3>
                {loading
                  ? "Waiting for Data"
                  : "Select Any Ticket To view Details"}
              </h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Helpandsupport;